"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifierCapitalize = void 0;
var isTypeString_1 = require("../../typeGuards/isTypeString");
var modifierCapitalize = function (value) {
    var _a;
    if (!isTypeString_1.isTypeString(value)) {
        console.log("UseForm: value must be a string to be modified by modifierToUpperCase");
        return value;
    }
    if (value.length === 0) {
        return value;
    }
    if (value.length === 1) {
        return value.charAt(0).toUpperCase();
    }
    return "" + value.charAt(0).toUpperCase() + ((_a = value === null || value === void 0 ? void 0 : value.substring(1)) === null || _a === void 0 ? void 0 : _a.toLowerCase());
};
exports.modifierCapitalize = modifierCapitalize;
//# sourceMappingURL=modifierCapitalize.js.map